import React from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DescriptionIcon from '@mui/icons-material/Description';
import { useNavigate } from 'react-router-dom';
import { getActiveBrandConfig } from '../../../../config/environment.config';
import useTailwindBrand from '../../../../Theme/useTailwindBrand';
import { useProcurationContext } from '../../../../Contexts/ProcurationContext';
import { useProcuration } from '../../../../Hooks/useProcuration';
import { RESET_AE_INFO } from '../../../../Redux/Reducers/ProcurationAeReducers';
import { RESET_SAP_INFO } from '../../../../Redux/Reducers/ProcurationSapReducers';
import ButtonField from '../../../../Components/Ui/ButtonField';

interface Props {
    file?: string;
    prevStep?: () => void;
    callBack?: () => void;
}

const LastProcuration = (props: Props) => {
    const { classes, common } = useTailwindBrand();
    const context = useProcurationContext();
    const { pdfDoc, teachr, triggerPdfUpdate, dispatch, typeOfProcuration } = context
    useProcuration({ pdfDoc, teachr, triggerPdfUpdate })
    const navigate = useNavigate();

    const changePage = () => {
        dispatch({ type: typeOfProcuration === 30 ? RESET_AE_INFO : RESET_SAP_INFO });
        navigate(`/${getActiveBrandConfig()}/tableau-de-bord/complete`, {
            state: { step: 3 },
        });
    };

    return (
        <div className="w-full h-full flex flex-col /items-center /justify-center /py-12 px-4">
            <div className="max-w-2xl w-full space-y-8">
                {/* Header */}
                <div className="flex flex-col items-center text-center space-y-4">
                    <div className="w-20 h-20 rounded-full bg-green-100 flex items-center justify-center">
                        <CheckCircleIcon className="w-12 h-12 text-green-500" />
                    </div>
                    <h2 className={`${classes.primaryText} ${classes.fontFamily} text-3xl lg:text-4xl font-bold`}>
                        Terminé ! 🎉
                    </h2>
                </div>

                {/* Content */}
                <div className="bg-white rounded-xl border border-gray-200 p-8 shadow-sm flex flex-col items-center gap-y-2">
                    <p className={`${common.body} ${classes.text} text-center leading-relaxed`}>
                        Votre procuration a bien été reçue. Celle-ci sera traitée dans les meilleurs délais par notre équipe.
                        Nous reviendrons vers vous dès que possible pour l'activation de votre compte.
                        Si vous avez une question, vous pouvez nous écrire à l'adresse{' '}
                        <a
                            href={`mailto:${process.env.REACT_APP_MAIL_SUPPORT}`}
                            className={`${classes.secondaryText} hover:underline font-semibold`}
                        >
                            {process.env.REACT_APP_MAIL_SUPPORT}
                        </a>
                    </p>
                    <a
                        href={teachr?.proofIsAE?.contentUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={`inline-flex items-center gap-2 ${classes.primaryText} ${classes.fontFamily} font-semibold hover:underline transition-colors text-center`}
                    >
                        <DescriptionIcon className="w-5 h-5" />
                        Télécharger ma procuration
                    </a>
                </div>

                {/* Actions */}
                <div className="flex flex-col items-center gap-4">
                    {/* <BrandButton
                        onClick={changePage}
                        className="w-full lg:w-auto px-10 py-3 font-semibold"
                    >
                        Finalisez votre inscription
                    </BrandButton> */}
                    <ButtonField
                        label={"Finalisez votre inscription"}
                        variant="contained"
                        className={`w-full font-bold lg:w-auto `}
                        onClick={changePage}
                    />
                    {props.file && (
                        <a
                            target="_blank"
                            rel="noopener noreferrer"
                            download
                            href={props.file}
                            className={`inline-flex items-center gap-2 cursor-pointer underline ${common.subtitle3} ${classes.primaryText} ${classes.fontFamily} hover:opacity-80 transition-opacity`}
                        >
                            <DescriptionIcon className="w-5 h-5" />
                            Télécharger ma procuration
                        </a>
                    )}
                </div>
            </div>
        </div>
    );
};

export default LastProcuration;
